import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';
import NewsList from './newsList/';
import NewBox from './newBox/';

const LeftBar = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            pureStream: PropTypes.array,
            mixStream: PropTypes.array,
            isEnd: PropTypes.bool,
            getMore: PropTypes.func,
            current: PropTypes.number,
        };

        render() {
            const { pureStream, isEnd, getMore, current, mixStream } = this.props;

            const stream = pureStream.map((item, index) => (
                <div className={current === index ? styles.show : styles.hide} key={index}>
                    {index === 0 ? (
                        <Chip
                            id="45021"
                            type="struct"
                            title="头条信息流顺序"
                            groupName="content"
                            content={mixStream}
                            translate="formatOrderStream"
                            translateOptions={{ list: mixStream }}>
                            <NewsList />
                        </Chip>
                    ) : null}
                    <NewsList content={item} />
                </div>
            ));

            return (
                <div className={styles.box_left}>
                    {stream}
                    {isEnd ? (
                        <p className={styles.noMore}>已显示全部</p>
                    ) : (
                        <div className={styles.loadMore} onClick={getMore}>
                            加载更多
                        </div>
                    )}
                </div>
            );
        }
    },
);

export { LeftBar };
export default LeftBar;
